// extracted by mini-css-extract-plugin
export default {"placeEventsTable":"places__placeEventsTable___[chunkhash-base64-5]"};